// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__3Hfyp","messages":"Chat_messages__2yV9S","dateDivider":"Chat_dateDivider__29qtg"};